import { DATA_GROUPS, DataGroupEnum, DataGroupType } from "@/components/refineRealEstate/dataGroupsConstants";
import { ActualUseEnum, BuildingTypeEnum, GeneralInfo, ObjectTypeEnum, OwnershipEnum } from "@/types/refineRealEstate";

const DATA_GROUPS_APARTMENT = DATA_GROUPS.filter((group) => group !== DataGroupEnum.plotData);
const DATA_GROUPS_PLOT = DATA_GROUPS.filter((group) =>
  [DataGroupEnum.generalInfo, DataGroupEnum.plotData].includes(group),
);

export const getAvailableTabs = (generalInfo: GeneralInfo, constructionYear?: number): DataGroupType[] => {
  const { objectType, buildingType, ownership, actualUse, selfUseSuitability } = generalInfo;

  const shouldHidePlotTab = (): boolean => {
    const isApartment = buildingType === ObjectTypeEnum.apartment;
    const isApartmentOwnership = ownership === OwnershipEnum.apartmentOwnership;

    if (!actualUse) return false;

    return (
      isApartment &&
      isApartmentOwnership &&
      ((selfUseSuitability === true &&
        (
          [
            ActualUseEnum.rented,
            // ActualUseEnum.empty
          ] as ActualUseEnum[]
        ).includes(actualUse)) ||
        ([ActualUseEnum.ownerOccupied, ActualUseEnum.partialOwnerOccupied] as ActualUseEnum[]).includes(actualUse))
    );
  };

  const shouldHideFinancialInfo = (): boolean => {
    const checkActualUse = (checkOwnerOccupied: boolean = true, checkRentedEmpty: boolean = true): boolean => {
      if (actualUse === undefined) return false;

      return (
        (checkOwnerOccupied &&
          ([ActualUseEnum.ownerOccupied, ActualUseEnum.partialOwnerOccupied] as ActualUseEnum[]).includes(actualUse)) ||
        (checkRentedEmpty &&
          selfUseSuitability === true &&
          (
            [
              ActualUseEnum.rented,
              //ActualUseEnum.empty
            ] as ActualUseEnum[]
          ).includes(actualUse))
      );
    };

    const hiddenCategories: BuildingTypeEnum[] = [
      BuildingTypeEnum.twoFamilyHouse,
      BuildingTypeEnum.singleFamilyHouseWithGrannyApartment,
      BuildingTypeEnum.apartment,
      BuildingTypeEnum.singleFamilyHouse,
    ];

    return buildingType ? hiddenCategories.includes(buildingType) && checkActualUse() : false;
  };

  const shouldHideModernizationTab = (): boolean => {
    if (!constructionYear) return false;
    const currentYear = new Date().getFullYear();
    return currentYear - constructionYear < 10;
  };

  const dataGroups =
    objectType === ObjectTypeEnum.plotOfLand
      ? DATA_GROUPS_PLOT
      : shouldHidePlotTab()
        ? DATA_GROUPS_APARTMENT
        : DATA_GROUPS;

  return dataGroups
    .filter((group) => group !== DataGroupEnum.financialAndRentalInfo || !shouldHideFinancialInfo())
    .filter((group) => group !== DataGroupEnum.modernization || !shouldHideModernizationTab());
};
